import { Link } from 'react-router-dom';
import { useFormatting, useTranslation } from '../../../i18n/i18n';
import { ActiveOrderData } from '../../../types';
import { orderStatusSummary } from '../../../utils/orderStatusSummary';
import './ActiveOrder.css';

interface ActiveOrderProps {
	order: ActiveOrderData;
}

export const ActiveOrder = ({ order }: ActiveOrderProps) => {
	const maxImagesToShow = order.items.length > 4 ? 3 : 4;
	const imagesToShow = order.items.slice(0, maxImagesToShow);
	const extraCount = order.items.length - imagesToShow.length;
	const showExtraCount = extraCount > 0;
	const productPreviewCellCount = imagesToShow.length + (showExtraCount ? 1 : 0);
	const { asPrice, dateTimeFormat } = useFormatting();
	const routes = useTranslation().routes;
	const t = useTranslation().orderPages;

	/* the whole row leads to the order, so nothing inside it is a link of its own - one inside another is not markup a browser keeps */
	return (
		<Link className="active-order" to={`${routes.yourOrders}/${order.id}`}>
			<div className="order-content">
				{productPreviewCellCount > 0 && (
					<div className={`product-preview product-preview--${productPreviewCellCount}`}>
						{imagesToShow.map((item) => (
							<div className="product-preview-cell" key={item.id}>
								<img src={item.image} alt={item.product.name} className="product-preview-image" />
							</div>
						))}

						{showExtraCount && (
							<div className="product-preview-cell product-preview-count">+{extraCount}</div>
						)}
					</div>
				)}

				<div className="order-summary">
					<div>{order.displayId}</div>
					<div>{dateTimeFormat(new Date(order.datePurchased))}</div>
					<div>
						{order.delivery.firstname} {order.delivery.lastname}
						<br />
						{order.delivery.city}
					</div>
					<div>{asPrice(order.totals)}</div>
					<div>{orderStatusSummary(order, t)}</div>
				</div>
			</div>

			{/* mobile layout */}
			<div className="order-summary-mobile">
				<div className="header">
					<span>
						<strong>{t.orderNumber}</strong>: {order.displayId}
					</span>
					<span className="date">{dateTimeFormat(new Date(order.datePurchased))}</span>
				</div>

				<hr className="divider" />

				<div className="section">
					<div className="label">{t.recipient}</div>
					<div className="value">
						{order.delivery.firstname} {order.delivery.lastname}, {order.delivery.city}
					</div>
				</div>

				<div className="two-col">
					<div>
						<div className="label">{t.orderValue}</div>
						<div className="value price">{asPrice(order.totals)}</div>
					</div>
					<div>
						<div className="label">{t.products}</div>
						<div className="value">{order.items.length}</div>
					</div>
				</div>

				<div className="section">
					<div className="label">{t.status}</div>
					<div className="value">{orderStatusSummary(order, t)}</div>
				</div>
			</div>
		</Link>
	);
};
